export const data = [
  {
    name: 'WeatherUnion',
    desc: 'A Zomato Giveback, weatherunion is India\'s first crowd-supported weather infrastructure. Multiple weather stations are installed across the country, largest on-ground network of weather stations.',
    link: 'https://weatherunion.com',
    hosted: true,
    available: true
  },
  {
    name: 'CodeShare',
    desc: 'A real-time code sharing platform which can be used for pair-programming or during interviews. Users can practice questions from the questions list extracted from leetcode. Code changes and compilation results are reflected in real-time.',
    link: 'https://jindal2209.github.io/CodeShareLive/',
    hosted: true,
    available: true
  },
  {
    name: 'Algolizer',
    desc: 'A collection of animated visualizations of various algorithms like flood-fill, backtracking, sorting and data-structures like graphs, tries, hashmaps, heaps.',
    link: 'https://jindal2209.github.io/Algolizer/',
    hosted: true,
    available: true
  },
  {
    name: 'Netflix Recommendation System',
    desc: 'Recommendation engine for netflix movies based on movie tags and user history Used KNN Algorithm and content based filtering using cosine vector and stemming.',
    link: '',
    hosted: true,
    available: false
  },
  {
    name: 'Invoice Application',
    desc: 'Created an Invoice application with CRUD operations where customer also receives email when the invoice is generated by the company and pay using a link provided in the email with invoice pdf attached. The project was created as a part of hackathon within 36 hours. Used ReactJS for front end and Django for backend.',
    link: 'https://jindal2209.github.io/InvoiceApplication/#/',
    hosted: true,
    available: true,
  },
  {
    name: 'URL Shortener',
    desc: 'A URL shortener using hashing.',
    link: 'https://bitny.herokuapp.com/',
    hosted: true,
    available: true,
  },
  {
    name: 'Text Editor Auto Suggestion',
    desc: 'A text editor that also provides suggestion based on previous text entered by the user. Data Structures used Tries, Maps, Graphs.',
    link: 'https://jindal2209.github.io/Text_Editor_Auto_Suggestion/',
    hosted: true,
    available: true
  },
  {
    name: 'Transaction Settlement',
    desc: 'An application that allows consumers to split expenses with friends similar to split-wise. Implemented using heaps. Implemented heap data structure in java-script.',
    link: 'https://jindal2209.github.io/transaction_settlement_splitwise/',
    hosted: true,
    available: true,
  },
  {
    name: 'Student Result Consolidation System',
    desc: 'An application that parses the PDF and stores the data in data-base. Back-end is developed using Django and front-end is developed using React. User can enter the enrollment number and check his/her results along with some data visualization using graphs and charts.',
    link: 'https://github.com/jindal2209/SRCS_Frontend',
    hosted: false,
    available: true
  },
  {
    name: 'College Website',
    desc: 'Created REST APIs for the college website using Django and Django-REST-Framework',
    link: 'http://www.bpitindia.com/',
    hosted: true,
    available: true
  },
  {
    name: 'Todo Application',
    desc: 'A to-do application to create and keep notes of daily tasks.',
    link: 'https://todowo.herokuapp.com/',
    hosted: true,
    available: true
  }
];